import React from 'react';
import { css, Global } from '@emotion/react';
import { theme } from '../../../../../domain/theme';
import { t } from '../../../../../domain/services/configService';
import { IconSearch } from '../../../../Icon/IconSearch';
import { ExpandedSearch } from '../../../../ExpandedSearch';
import { IconClose } from '../../../../Icon/IconClose';

const styles = {
  searchIcon: css`
    display: grid;
    place-items: right;
    height: 50px;
    padding: ${theme.spacing.parse('0 $xs')};
    display: grid;
    place-items: center;
    line-height: initial;
    svg {
      cursor: pointer;
    }
  `,
  closeSearchIcon: css`
    position: absolute;
    top: 2rem;
    right: 2rem;
    width: 24px;
    height: 24px;
    z-index: 999;
    svg {
      cursor: pointer;
    }
  `,
  hidden: css`
    display: none;
  `,
  modalSearchToggle: css`
    &:checked ~ .modal-search {
      display: block;
      z-index: 999;
    }
  `,
  modalSearch: css`
    display: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: #000;
    z-index: -999;
  `
};

export const SearchMenuItem = () => {
  return (
    <>
      <Global
        styles={css`
          body:has(input[type='checkbox']#search-toggle:checked) {
            overflow: hidden;
            #main-navigation-nav[data-is-sticky='true'] {
              transition: none;
              transform: unset;
            }
          }
        `}
      />

      <div css={styles.searchIcon} title={t('Search')}>
        <label htmlFor="search-toggle">
          <span css={styles.hidden}>{t('Search')}</span>
          <IconSearch />
        </label>
      </div>

      <input
        type="checkbox"
        css={[styles.modalSearchToggle, styles.hidden]}
        id="search-toggle"
      />

      <div css={styles.modalSearch} className="modal-search">
        <ExpandedSearch />

        <div css={styles.closeSearchIcon} title={t('close')}>
          <label htmlFor="search-toggle">
            <span css={styles.hidden}>{t('close')}</span>
            <IconClose color="#fff" />
          </label>
        </div>
      </div>
    </>
  );
};
